<script setup lang="ts">
import { useUserAvailability } from '@hooks/auth/user-availability.hook'

import { BtnToggle } from '@UI/Buttons/BtnToggle'
import { AppText } from '@UI/Typography/AppText'
import { AppIcon } from '@UI/Icons/AppIcon'
import { ModalConfirmation } from '@UI/Modals/ModalConfirmation'

defineOptions({
  name: 'UserAvailability',
})

const {
  isAvailable,
  statusText,
  modal,
  isModalShown,
  isLoading,
  setModalShown,
  setAvailability,
} = useUserAvailability()
</script>

<template>
  <div class="user-availability">
    <div
      class="user-availability__toggle"
      :title="statusText"
      @click="setModalShown(true)"
    >
      <BtnToggle
        color="emerald"
        tooltip-text="Change status"
        :checked="isAvailable"
        :disabled="isLoading"
        :readonly="true"
      />
      <AppText
        name="body1"
        tag="span"
        color="slate-900"
        class="user-availability__text"
      >
        {{ statusText }}
      </AppText>
    </div>
    <ModalConfirmation
      :show="isModalShown"
      :mode="modal.mode"
      :title="modal.title"
      :detail="modal.detail"
      :button-title="modal.title"
      :loading="isLoading"
      @click:confirm="setAvailability"
      @click:cancel="setModalShown(false)"
    >
      <template #icon>
        <AppIcon
          :icon="modal.icon"
          :color="modal.iconColor"
        />
      </template>
    </ModalConfirmation>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/UserAvailability.scss" />
